import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { clientRoute } from '../route';

import { clientTransactionsFilterFormSchema } from './helpers/clientTransactionsFilterFormSchema';

const clientTransactionsValidateSearch = z.object({
	filter: clientTransactionsFilterFormSchema.catch({
		processStatus: 'active',
	}),
	currencyCode: z.string().optional().nullable(),
});

export const clientTransactionsRoute = createRoute({
	path: '/transactions/$accountUuid',
	getParentRoute: () => clientRoute,
	validateSearch: clientTransactionsValidateSearch,
});

export type ClientTransactionsValidateSearch = z.infer<
	typeof clientTransactionsValidateSearch
>;
